
export enum Membership {
    Free = 'Free',
    Premium = 'Breathe+',
}

export interface User {
    id: string;
    name: string;
    membership: Membership;
}

export interface Module {
    title: string;
    slug: string;
    summary: string;
    level: string;
    is_premium: boolean;
    order: number;
    tags: string[];
}

export enum LessonType {
    Audio = "Audio",
    Video = "Video",
    Text = "Text",
}

export interface Lesson {
    title: string;
    slug: string;
    module: string;
    type: LessonType;
    media_url: string;
    duration_min: number;
    summary: string;
    is_premium: boolean;
}

export interface AudioTrack {
    title: string;
    slug: string;
    audio_url: string;
    intention: 'Sleep' | 'Focus' | 'Relax' | 'Energy';
    is_premium: boolean;
    duration_min: number;
}

export interface Book {
    title: string;
    author: string;
    summary: string;
    is_premium_notes: boolean;
}

export interface Note {
    id: string;
    user_id: string;
    template: string;
    content: string;
    timestamp: string;
    lesson_slug?: string;
}

export interface AISuggestion {
    suggestion_title: string;
    description: string;
    next_action: string;
}
